import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { InformationCreationModel } from "../../models/information.model";
import { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";

interface ViewCollectableInformationProps {
  informationToShow?: InformationCreationModel | null | undefined;
  onClose: () => any;
}

export default function ViewCollectableInformation({
  informationToShow,
  onClose,
}: ViewCollectableInformationProps) {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setOpen(!!informationToShow);
  }, [informationToShow]);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Collectable Data</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2, fontSize: 14 }}>
            Collectable data fields that your agents can use to gather
            information from users. This data can help you generate leads and
            grow your sales.
          </DialogContentText>

          <Stack spacing={2}>
            <Box>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent={"space-between"}
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "text.secondary", mb: 0.5, fontSize: 14 }}
                >
                  Name
                </Typography>
              </Stack>

              <Typography
                variant="body1"
                sx={{
                  whiteSpace: "pre-wrap",
                  fontSize: 16,
                }}
              >
                {informationToShow?.propertyLabel || "No name provided ..."}
              </Typography>
            </Box>

            <Box>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent={"space-between"}
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "text.secondary", mb: 0.5, fontSize: 14 }}
                >
                  Description
                </Typography>
              </Stack>

              <Typography
                variant="body1"
                sx={{
                  whiteSpace: "pre-wrap",
                  fontSize: 16,
                }}
              >
                {informationToShow?.propertyDescription ||
                  "No description provided ..."}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
